import type { ReactNode } from 'react';
import type { FilterConfig } from '@alltrails/denali/components/FilterBar';
import type ExploreServiceFilters from '../../types/ExploreServiceFilters';
import FilterControlV2 from '../FilterControlV2/FilterControlV2';
import type { ChipsFilterConfigV2 } from '../FilterControlV2/types';
import styles from './buildChipsDropdownConfig.module.scss';

/**
 * Config for a bespoke chips config used in explore.
 *
 * https://www.figma.com/design/xr7AP5Bd1HcO5syL0nNhwZ/Explore-Usability-H2-2026?node-id=215-22416&m=dev
 */
export default function buildChipsDropdownConfig(
  chipsConfig: ChipsFilterConfigV2,
  filters: ExploreServiceFilters,
  onFiltersChange: (updatedFilters: ExploreServiceFilters) => void,
  additionalContent?: ReactNode
): FilterConfig {
  const selectedItems = chipsConfig.selectionChips.selectedChips?.map(chip => chip.label) ?? [];
  const hasSelection = selectedItems.length > 0;

  return {
    type: 'custom-dropdown',
    id: chipsConfig.id,
    filterChip: {
      unselectedText: chipsConfig.selectionChips.title,
      selectedItems: hasSelection ? selectedItems : undefined,
      onClear: hasSelection
        ? () => {
            const updatedFilters = { ...filters };
            // chipsConfig.id is the explore-service filter key (e.g. "difficulty", "feature", "activity").
            delete (updatedFilters as Record<string, unknown>)[chipsConfig.id];
            onFiltersChange(updatedFilters);
          }
        : undefined
    },
    content: (
      <div className={styles.chipsDropdown}>
        <FilterControlV2 filterConfig={chipsConfig} />
        {additionalContent && <div className={styles.additionalContent}>{additionalContent}</div>}
      </div>
    )
  };
}
